import { render, staticRenderFns } from "./servicosSolicitados.vue?vue&type=template&id=5ab7f1c9&scoped=true&"
import script from "./servicosSolicitados.vue?vue&type=script&lang=js&"
export * from "./servicosSolicitados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab7f1c9",
  null
  
)

export default component.exports